import { useEffect, useRef } from "react";

// Proteção contra perda de preenchimento (item 13 do pedido — reutilizado
// por Ficha de Visita e Novo Cliente, nunca duas implementações
// diferentes). Compara o valor atual do formulário contra uma "fotografia"
// capturada no instante em que o modal abriu — editar um registro já
// existente só conta como "alterado" depois que o usuário de fato mexe em
// algo, nunca só por abrir a tela de edição já preenchida.
export function useDirty(open, value) {
  const baselineRef = useRef(null);
  useEffect(() => {
    baselineRef.current = open ? JSON.stringify(value) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  if (!open || baselineRef.current === null) return false;
  return JSON.stringify(value) !== baselineRef.current;
}
